import {
    MissingDeviceCredentialError,
    MissingRefreshTokenError,
} from '@/features/api/terminal/errors'
import { logoutCurrentProfile, logoutDevice } from '@/redux/reducers/auth/actions'
import { Store } from '@/redux/store'
import { AxiosInstance, AxiosResponse } from 'axios'

let store: Store

export const injectStoreInMissingAuthCredentialInterceptor = (_store: Store) => {
    store = _store
}

export class MissingAuthCredentialInterceptor {
    private axiosInstance: AxiosInstance

    constructor(axiosInstance: AxiosInstance) {
        this.axiosInstance = axiosInstance

        this.attachInterceptor()
    }

    private attachInterceptor = (): void => {
        this.axiosInstance.interceptors.response.use((response) => response, this.onResponseError)
    }

    private onResponseError = async (error: unknown): Promise<AxiosResponse | undefined> => {
        if (error instanceof MissingDeviceCredentialError) {
            store.dispatch(logoutDevice())

            return
        }

        if (error instanceof MissingRefreshTokenError) {
            store.dispatch(logoutCurrentProfile())

            return
        }

        throw error
    }
}
